export const positiveOrZero = (
  value: string | number | undefined
): number | string =>
  !value || value < 0 || parseInt(value as string) < 0 ? 0 : value;
